// extracted by mini-css-extract-plugin
export default {"base":"LocationSettingsPage_base__n7yit","headar":"LocationSettingsPage_headar__U4AJs","footer":"LocationSettingsPage_footer__LiuWT","body":"LocationSettingsPage_body__tX5fW"};